import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaginationComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  @Input() small: boolean;
  @Input() pageIndex: number = 0;
  @Input() pageSize: number;
  @Input() totalCount: number = null;
  @Input() enablePagedRoute: boolean = false;
  @Input() sizes = [5, 10, 20, 50, 100];

  @Output() changePagination = new EventEmitter<{ page: number, size: number; }>();

  selectedSize: number
  pagesTotal: number;
  currentPage: number;
  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pageSize) {
      if (!this.pageSize) this.pageSize = this.sizes[1];
      if (!this.sizes.some(x => x === this.pageSize)) {
        this.sizes.push(this.pageSize);
        this.sizes = this.sizes.sort((n1, n2) => {
          if (n1 > n2) return 1;
          if (n1 < n2) return -1;
          return 0;
        });
      }
      this.sizeSelected();
    }

    if (changes.totalCount && this.totalCount)
      this.pagesTotal = Math.ceil(this.totalCount / this.pageSize);

    if (changes.pageIndex && !changes.pageIndex.firstChange) {
      this.currentPage = this.pageIndex + 1;
      this.changeQuery();
    }
  }

  ngOnInit() {
    this.currentPage = this.pageIndex + 1;
  }

  ngAfterViewInit() {
    if (this.enablePagedRoute)
      setTimeout(() => this.checkInitRoute());
  }

  ngOnDestroy() {
    // if (this.enablePagedRoute)
    //   this.router.navigate([], { skipLocationChange: true, queryParamsHandling: 'merge', queryParams: { pageSize: null, pageNumber: null } });
  }

  checkInitRoute() {
    const query = this.activeRoute.snapshot.queryParams;
    if (query.pageSize) {
      this.sizes.some(x => x === +query.pageSize) ?
        this.pageSize = Number(query.pageSize) === 0 ? this.sizes[1] : Number(query.pageSize) :
        this.pageSize = this.sizes[1];
      this.sizeSelected();
    }
    if (query.pageNumber) {
      if (isNaN(Number(query.pageNumber))) {
        this.pageIndex = 0;
        this.currentPage = 1;
      } else {
        this.pageIndex = Number(query.pageNumber) === 0 ? 1 : Number(query.pageNumber) - 1;
        this.currentPage = Number(query.pageNumber);
      }
    }
    this.changeQuery();
    this.onChangePagination();
  }

  sizeSelected() {
    this.selectedSize = this.sizes.find(x => x == this.pageSize);
  }

  onChangeSize() {
    this.selectedSize = +this.selectedSize;
    this.pageSize = this.selectedSize;
    this.pagesTotal = Math.ceil(this.totalCount / this.pageSize);
    this.pageIndex = 0;
    this.changeQuery();
    this.onChangePagination();
  }

  onChangePage(page: number) {
    this.pageIndex = page;
    this.currentPage = this.pageIndex + 1;
    this.changeQuery();
    this.onChangePagination();
  }

  onChangePageIndex(ev: any) {
    const n = ev.srcElement.value;
    const val = Math.floor(!!n ? +n : 0);
    this.currentPage = val < 1 ? 1 : (val > this.pagesTotal) ? this.pagesTotal : val;
    this.onChangePage(this.currentPage - 1);
  }

  onChangePagination() {
    this.changePagination.emit({ page: this.pageIndex, size: this.pageSize });
  }

  changeQuery() {
    if (this.enablePagedRoute)
      this.router.navigate(['.'], { relativeTo: this.activeRoute, replaceUrl: true, queryParamsHandling: 'merge', queryParams: { pageSize: this.pageSize, pageNumber: this.pageIndex + 1 } });
  }
}
